import { Link } from 'react-router-dom';
import { ArrowUpRight, HeartPulse, Shield, TrendingUp } from 'lucide-react';
import { PHONES } from '../../lib/site';

const SERVICES = [
  { key: 'medicare', title: 'Medicare', copy: 'Plan selection, Advantage vs. Medigap, enrollment help and annual reviews.', to: '/medicare', Icon: HeartPulse, phone: PHONES.medicare },
  { key: 'insurance', title: 'Life Insurance', copy: 'Term, whole life, IUL and final expense coverage that protects the people you love.', to: '/insurance', Icon: Shield, phone: PHONES.financial },
  { key: 'retirement', title: 'Retirement Planning', copy: 'Pension estimates, income solutions and tax-smart retirement strategies.', to: '/retirement-planning', Icon: TrendingUp, phone: PHONES.financial },
];

const CardBody = ({ s, i }) => (
  <>
    <div className="flex items-start justify-between">
      <div className="w-12 h-12 rounded-2xl bg-orange-500/15 border border-orange-400/30 flex items-center justify-center">
        <s.Icon className="w-6 h-6 text-orange-300" />
      </div>
      <span className="font-display text-sm text-slate-500">0{i + 1}</span>
    </div>
    <h3 className="font-display text-2xl font-semibold text-white mt-8 mb-2">{s.title}</h3>
    <p className="text-sm text-slate-400 leading-relaxed flex-1">{s.copy}</p>
    <div className="mt-6 flex items-center justify-between text-sm">
      <span className="text-slate-500">{s.phone ? s.phone.display : ''}</span>
      <span className="inline-flex items-center gap-1 font-semibold text-orange-400 group-hover:text-orange-300">
        Explore <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
      </span>
    </div>
  </>
);

export const ServiceLinks = () => (
  <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
    {SERVICES.map((s, i) => (
      <Link key={s.key} to={s.to} data-testid={`service-link-${s.key}`}
        className="group glass-panel rounded-3xl p-7 flex flex-col min-h-[280px] hover:border-orange-400/50 hover:-translate-y-1.5 rise-in"
        style={{ animationDelay: `${300 + i * 90}ms` }}>
        <CardBody s={s} i={i} />
      </Link>
    ))}
  </div>
);
